import React from "react";

type SubmitButtonProps = {
  onClick?: () => void;
  isPending?: boolean;
  children: React.ReactNode;
  extraClasses?: string;
  extraProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
    type?: "button" | "submit" | "reset";
};

const SubmitButton = ({
  onClick,
  isPending = false,
  children,
  extraClasses = "",
  extraProps = {},
  type
}: SubmitButtonProps) => {
  const isDisabled = isPending || extraProps.disabled;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      type={type}
      className={`border ${
        isDisabled
          ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
          : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
      } flex items-center justify-center rounded-full p-2 px-6 space-x-1 text-base font-medium ${extraClasses}`}
      {...extraProps}
    >
      {isPending && (
        <svg
          className="animate-spin h-5 w-5 text-white mr-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
          />
        </svg>
      )}
      <span>{children}</span>
    </button>
  );
};

export default SubmitButton;
